import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as badgeSt from './badge.module.scss'

export interface IRuntimeBadgeProps extends AtfTreatmentProps {
  runtime?: string
}

export const Runtime = ({ runtime, atfTreatment }: IRuntimeBadgeProps) => (
  runtime &&
    (<Badge use={badges.TEXT}>
      <span {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} data-automation-id="runtime-badge">{runtime}</span>
    </Badge>) || null
)
